import ButtonMailto from "../../atoms/button/button-mail-to";

import useScrollListener from "../../hooks/useScrollListener";


import Footer from "../../components/footer/footer.component";
 import { 
	PrivacyLegalRouteContainer, 
	PrivacyLegalContainer
 } from "./privacylegal.styles";
 
 
 const PrivacyLegal = ({ onScroll }) => {
	 const contentRef = useScrollListener(onScroll);
 
	 return (
		 <PrivacyLegalRouteContainer  ref={contentRef}>
				 <PrivacyLegalContainer theme={{ hoverBg: 'white', hoverBrd: 'black' }}>
					 <div className='about-info' >
                        <h2>Privacy & Legal</h2>
                        
                        <p><b>Your Privacy Matters</b></p>
                        <p>At Tree, we take your privacy seriously.</p>
                        <p>When you trust us with your information, we’re committed to protecting it with the utmost care.</p>
                        <p>We only collect the data we need to provide you with the best possible service and ensure that your experience with us is smooth and secure.</p>
                        <p>We never sell or share your information with third parties unless it's necessary to complete your request or required by law.</p>

                        <p><b>What We Collect</b></p>
                        <p>When you interact with us, we may collect certain details such as your name, email address, phone number, and any other information you choose to provide.</p>
                        <p>We use this information to:</p>

                        <ul>
                            <li>Respond to your inquiries.</li>
                            <li>Provide the services you’ve requested.</li>
                            <li>Improve our website and services.</li>
                        </ul>
                        
                        <p><b>How We Protect Your Data</b></p>
                        <p>Your data is stored securely, and we use industry-standard encryption and security measures to keep it safe.</p>
                        <p>Access to your information is restricted to those who need it to perform their job, ensuring your data is only handled by trusted members of our team.</p>

                        <p><b>Legal Stuff</b></p>
                        <p>By using our website or services, you agree to our terms and conditions.</p>
                        <p>We work hard to make sure everything we do is transparent and in your best interest.</p>
                        <p>If you ever have any questions or concerns about our policies, don’t hesitate to reach out.</p>

                        <p><b>Updates</b></p>
                        <p>We may update our privacy and legal policies from time to time.</p>
                        <p>When we do, we'll make sure you know about it, so you can stay informed on how we’re protecting your information.</p>

                        <p><b>Get in Touch</b></p>
                        <p>If you have any questions about our privacy practices or legal terms, we're here to help.</p>
                        <p>Just send us a message, and we'll get back to you as soon as we can.</p>

                        <p>Your trust means the world to us, and we’re committed to keeping it. 🌱</p>

						 <p>Social Media: @treegotyou</p>
						 <p>Email: treegotyou@gmail.com</p>
						 
						 {/* <Button text="CONTACT US" loc="/company/PrivacyLegal" /> */}
						 
					 </div>
                     <div class="klaviyo-form-RaLuFy"></div>
					 <Footer />
				 </PrivacyLegalContainer>
		 </PrivacyLegalRouteContainer>
	 )
 }
 
 export default PrivacyLegal;